import type { RealtimeClientEvent } from '@wundo/shared/realtimeVoice.ts';

/*
 * A little over the bridge's own bound on a hang-up, so a bridge that answers
 * is always waited for and one that does not still lets the user go.
 */
export const HANG_UP_TIMEOUT_MS = 6_000;

/**
 * The debrief is asked for right after a hang-up, so the bridge is first given
 * the chance to write down or mark the last thing said. It closes the socket
 * once it has; this resolves then, or at the timeout.
 */
export async function hangUpVoiceSocket(
  socket: WebSocket | null,
  timeoutMs = HANG_UP_TIMEOUT_MS,
): Promise<void> {
  if (socket?.readyState !== WebSocket.OPEN) {
    socket?.close(1_000);
    return;
  }

  await new Promise<void>((resolve) => {
    const timer = setTimeout(resolve, timeoutMs);
    socket.addEventListener('close', () => {
      clearTimeout(timer);
      resolve();
    });
    socket.send(JSON.stringify({ type: 'hang_up' } satisfies RealtimeClientEvent));
  });
  socket.close(1_000);
}
